import { ApplicationState } from '../../../../store/types';
import { getSystemMaintenanceRoot } from '../../store/selectors';
import { SystemMaintenanceDB } from './types';

export const getIsUpdatingSystemMaintenance = (state: ApplicationState): boolean => getSystemMaintenanceRoot(state).isSaving;

export const getCurrentSystemMaintenance = (state: ApplicationState): SystemMaintenanceDB[] => getSystemMaintenanceRoot(state).currentSystemMaintenanceSections;
